/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UsersServicesLiesGridDto
 */
export interface UsersServicesLiesGridDto {
    /**
     * 
     * @type {number}
     * @memberof UsersServicesLiesGridDto
     */
    idservice?: number;
    /**
     * 
     * @type {string}
     * @memberof UsersServicesLiesGridDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the UsersServicesLiesGridDto interface.
 */
export function instanceOfUsersServicesLiesGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UsersServicesLiesGridDtoFromJSON(json: any): UsersServicesLiesGridDto {
    return UsersServicesLiesGridDtoFromJSONTyped(json, false);
}

export function UsersServicesLiesGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersServicesLiesGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idservice': !exists(json, 'idservice') ? undefined : json['idservice'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function UsersServicesLiesGridDtoToJSON(value?: UsersServicesLiesGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idservice': value.idservice,
        'nom': value.nom,
    };
}

